<!-- Business Navbar -->
<bc-business-navbar
  [serviceProviderId]="serviceProviderId"
  [partnerId]="(atlasIdentifier$ | async)?.partnerId"
  [accountId]="(atlasIdentifier$ | async)?.accountId"
  [hideNotifications]="false"
  [hideCenters]="false"
  [defaultURL]="WSPdefaultURL"
  entitlementId="partner-access"
></bc-business-navbar>
